module.exports = __webpack_public_path__ + "static/media/bees-illustration-2.22444d55.png";